import * as React from "react";
import {Button, FormControlLabel, FormGroup, Grid, Switch, TextField} from "@material-ui/core";
import {API} from "aws-amplify";
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";
import {Alert} from "@material-ui/lab";
import {LoadingSpinner} from "../../../../utils/LoadingSpinner";
import {
    getSchedulesByContractIdDefault,
    IGetSchedulesByContractIdRequest
} from "./request/GetSchedulesByContractIdRequest";
import { AMAZON_ID } from "../../../../consts/Patterns";
import { Programs } from "../../../../consts/PacMan";

interface IProps {
    data?: any
}

interface IState {
    errorMessage: string
    isJsonInput: boolean
    isLoading: boolean
    jsonInput: string
    request: IGetSchedulesByContractIdRequest
    response: any
}

enum InputField {
    CONTRACT_ID,
    PROGRAM_NAME
}

class GetSchedulesByContractIdSection extends React.Component<IProps, IState> {
    private isValidation: boolean;
    constructor(props: IProps) {
        super(props);

        this.state = {
            errorMessage: '',
            isJsonInput: false,
            isLoading: false,
            jsonInput: getSchedulesByContractIdDefault,
            request: { programName: Programs.AP_PILLPACK } as IGetSchedulesByContractIdRequest,
            response: ''
        };

        this.toggleJsonInput = this.toggleJsonInput.bind(this);
        this.setRequest = this.setRequest.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
    }

    public render() {
        return(
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Alert variant="filled" severity="info">
                    Please note that it can take up to 2 minutes for schedule and benefit information to be available after
                    creating a contract.
                </Alert>

                <Grid item xs>
                    <FormGroup>
                        <FormControlLabel control={ <Switch onChange={ this.toggleJsonInput }/> } label="Toggle Json Input" />
                    </FormGroup>
                </Grid>


                { !this.state.isJsonInput &&
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Contract Id (Required)"
                                variant="outlined"
                                value={ this.state.request.contractId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.CONTRACT_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="ProgramName (Required)"
                                variant="outlined"
                                value={ this.state.request.programName || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PROGRAM_NAME, event) }
                            />
                        </Grid>
                    </Grid>
                }

                { this.state.isJsonInput &&
                    <Grid item xs>
                        <TextField
                            multiline
                            rows={ 8 }
                            label="Get Schedules By Contract Id Request"
                            variant="filled"
                            value={ this.state.jsonInput }
                            onChange={ this.setRequest }
                            style={{ width: 800 }}
                        />
                    </Grid>
                }

                <Grid item xs>
                    <Button variant="outlined" color="default" onClick={ this.handleSubmit }>
                        Submit
                    </Button>
                </Grid>

                { this.state.isLoading && <LoadingSpinner/> }

                { this.state.errorMessage &&
                    <Alert variant="filled" severity="info">
                        Error encountered: { this.state.errorMessage }
                    </Alert>
                }

                { this.state.response &&
                    <div>
                        <br/>
                        <h4>Status</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <JsonRenderComponent jsonObject={ this.state.response } printHtml={ false }/>
                        </p>
                    </div>
                }
            </Grid>
        );
    }

    private toggleJsonInput() {
        this.setState({ isJsonInput: !this.state.isJsonInput });
    }

    private handleValidation(request : IGetSchedulesByContractIdRequest) {
        let formIsValid = true;
        if (!request.contractId) {
            alert('Please enter the contract id');
            formIsValid = false
        } else if (!request.contractId.match(AMAZON_ID)) {
            alert('Please enter the valid contract id.');
            formIsValid = false
        }
        if (!request.programName) {
            alert('Please enter the programName');
            formIsValid = false
        }
        return formIsValid;
    }
    private setRequestFields(field: InputField, event: React.ChangeEvent<HTMLTextAreaElement>) {
        const updatedRequest: IGetSchedulesByContractIdRequest = this.state.request;

        switch (field) {
            case InputField.PROGRAM_NAME: {
                updatedRequest.programName = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            case InputField.CONTRACT_ID: {
                updatedRequest.contractId = event.target.value;
                this.setState({ request: updatedRequest });
                console.log(this.state.request);
                break;
            }
            default: {
                break;
            }
        }
    }

    private setRequest(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ jsonInput: event.target.value });
    }

    private handleSubmit() {
        this.setState({ isLoading: true });
        this.setState({ errorMessage: '' });
        let body: IGetSchedulesByContractIdRequest;

        if (this.state.isJsonInput) {
            body = JSON.parse(this.state.jsonInput);
            this.isValidation = this.handleValidation(body);
        } else {
            body = this.state.request;
            this.isValidation = this.handleValidation(body);
        }

        if (this.isValidation) {
            const config = {
                body,
                headers: {}
            }
            this.callGetSchedulesByContractId(config);
        }
        this.setState({ isLoading: false });
    }

    private callGetSchedulesByContractId(config: any) {
        const apiName = 'ApaqPortalAPI';
        const path = '/pharmacy-customer/get-schedules-by-contractid';

        console.log(config)
        API.post(apiName, path, config).then((getEnrollmentResponse: any) => {
            console.log(getEnrollmentResponse);
            let json = JSON.stringify(getEnrollmentResponse, undefined, 4);
            json = json.replace('"response": "{', '')
                .replace('}"', '')
                .split('\\"').join('"');
            const jsonObj = JSON.parse(json)

            this.setState({ response: jsonObj });
            this.setState({ errorMessage: ''})
        }).catch((error) => {
            console.log(error);
            this.setState({ response: ''})
            this.setState({ errorMessage: error.response.data.message });
        });
    }
}

export default GetSchedulesByContractIdSection;
